










































































































































































import Vue from "vue";
import { Header } from "../../MyTable.vue";
import { mapActions, mapState, mapMutations } from "vuex";
import { Terminal } from "xterm";
import { AttachAddon } from "xterm-addon-attach";

import "xterm/css/xterm.css";
import { axios } from "@/plugins";

const headers: Header[] = [
  { title: "Pod名称", key: "containerName", minWidth: 200 },
  { title: "容器名称", key: "", width: 180 },
  { title: "端口", key: "", width: 140 },
  { title: "状态", key: "" },
  { title: "运行时间", key: "", width: 180 },
  { title: "操作", key: "", width: 80 }
];

export default Vue.extend({
  name: "Log",
  props: {
    data: { type: Object },
    projectId: { type: String }
  },
  data() {
    return {
      headers,
      showLog: false,
      timer: 0,
      viewMode: "TAILLINES",
      connectParam: "100",
      viewOptions: ["TAILF", "TAILLINES", "GREP"],
      showShell: false,
      showMonitor: false,
      ws: (null as any) as WebSocket,
      term: (null as any) as Terminal,
      tableData: [] as any[],
      // // 翻页禁止参数
      disabled: false,
      // 查询日志的数据
      logData: {
        namespace: "",
        projectId: "",
        podName: "",
        container: "",
        viewMode: "",
        connectParam: ""
      },
      // 资源监控数据
      monitorData: null as any,
      lineList: [
        { title: "CPU 负载(%)", name: "podCpuUsage" },
        { title: "内存使用量(MB)", name: "podMemoryUsage" },
        { title: "网络流出速率(bps)", name: "podNetBytesTransmitted" },
        { title: "网络流入速率(bps)", name: "podNetBytesReceived" }
      ]
    };
  },
  computed: {
    ...mapState("PrjContainers/Log", ["logs", "loading", "hasMore", "wsRuning"])
  },
  mounted() {
    this.getTable();
  },
  beforeDestroy() {
    this.closeAll();
    this.clearLogs();
  },
  methods: {
    ...mapActions("PrjContainers/Log", [
      "init",
      "close",
      "connect",
      "nextPage",
      "wsInit",
      "wsStop",
      "downloadLogs"
    ]),
    ...mapMutations("PrjContainers/Log", { clearLogs: "CLEAR_LOG" }),
    getTable() {
      axios
        .get(
          `/pod/container/details?projectId=${this.projectId}&containerName=${this.data.metadata.name}`
        )
        .then(res => {
          this.tableData = res.data.data;
        });
    },
    handleCommand(
      type: "log" | "shell" | "upload" | "podDownload" | "monitor",
      data: any
    ) {
      this[type](data);
    },

    monitor(data: any) {
      this.monitorData = data.podName;
      this.showMonitor = true;
    },
    connectParamChange(val: string) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (val) {
          this.connect({ logData: this.logData, el: this.$refs.logs });
        }
      }, 300);
    },
    log(data: any) {
      this.showLog = true;
      this.logData = {
        namespace: data.namespace,
        projectId: this.projectId,
        podName: data.podName,
        container: data.containerName,
        viewMode: this.viewMode,
        connectParam: this.connectParam
      };
      this.$nextTick(() => {
        this.init({ logData: this.logData, el: this.$refs.logs });
      });
    },
    logConnect(val: string) {
      if (val === "TAILLINES") {
        this.logData.connectParam = "100";
      } else {
        this.logData.connectParam = "";
      }
      if (val !== "GREP") {
        this.connect({ logData: this.logData, el: this.$refs.logs });
      }
    },
    logNextPage() {
      this.nextPage(this.$refs.logs);
    },
    getHeightLight(data: string) {
      if (this.logData.viewMode === "GREP" && this.logData.connectParam) {
        const reg = new RegExp(this.logData.connectParam, "gi");
        return data
          .replace("<", "&lt;")
          .replace(">", "&gt;")
          .replace(reg, str => `<b>${str}</b>`);
      }
      return data;
    },
    shell(data: any) {
      this.showShell = true;

      this.$nextTick(() => {
        const { height } = (document.querySelector(
          "#shell"
        ) as HTMLElement).getBoundingClientRect();

        this.term = new Terminal({
          lineHeight: 1.2,
          fontSize: 14,
          cols: 80,
          rows: Math.floor(height / 19)
        });

        let url = "wss://gavialstone.mlogcn.com";
        if (process.env.NODE_ENV === "production") {
          url = `${location.protocol === "http:" ? "ws" : "wss"}://${
            location.host
          }`;
        }
        this.ws = new WebSocket(
          `${url}/ws/shell?projectId=${this.projectId}&pod=${data.podName}&container=${data.containerName}`
        );
        this.term.loadAddon(new AttachAddon(this.ws));
        this.term.open(document.querySelector("#shell") as HTMLElement);

        setTimeout(() => {
          this.term.focus();
        }, 0);
      });
    },
    shellBoxClick() {
      this.term && this.term.focus();
    },
    download() {
      this.downloadLogs(
        `container=${this.logData.container}&pod=${this.logData.podName}&namespace=${this.logData.namespace}`
      );
    },
    upload(data: any) {
      (this.$refs.upload as any).show({
        url: "/pod/file/upload/project",
        form: {
          projectId: this.projectId,
          pod: data.podName,
          container: data.containerName
        }
      });
    },
    podDownload(data: any) {
      (this.$refs.download as any).show(
        `/pod/file/download/project?projectId=${this.projectId}&pod=${data.podName}&container=${data.containerName}&path=`
      );
    },
    closeAll() {
      this.showLog = false;
      this.showShell = false;
      this.showMonitor = false;
      this.close();
      this.clearLogs();
      this.term && this.term.dispose();
      this.ws && this.ws.close();
    }
  }
});
